import { mapGetters } from 'vuex';
import offersMixin from '../offers';
import determineActivePriceMixin from '../determineActivePrice';

const track = (content) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(content);
};

const resolvePath = ($route, origin) => {
  const routes = ['/simulador'];

  if ($route.params.package) {
    routes.push(`/${$route.params.package}`);
  }

  if ($route.params.coverage) {
    routes.push(`/${$route.params.coverage}`);
  }

  return routes.join('') + origin;
};
export default {
  mixins: [
    offersMixin,
    determineActivePriceMixin
  ],
  computed: {
    ...mapGetters({
      cart: 'cart/getContent',
      simulationPackage: 'simulation/getPackage',
      simulationTrackingPackage: 'simulation/getTrackingPackage',
      cartStringifiedContent: 'cart/getTrackingContent',
      globalConfig: 'packages/getConfig'
    })
  },
  methods: {

    $gm_tracker_trackMSA(data) {
      const url = window.location.href;

      const content = {
        event: data.event,
        page_title: data.title,
        step_name: data.name,
        page_url: url,
        step_number: data.step
      };

      if (data.class) content.simulator_class = data.class;

      if (data.subClass) content.simulator_sub_class = data.subClass;

      if (data.quantity) content.quantity_plans_added = data.quantity;

      if (data.fidelization) content.fidelity_months = data.fidelization;

      if (data.value) content.value = data.value;

      if (data.electronicReceipt) content.electronic_receipt = data.electronicReceipt;

      if (data.directDebit) content.direct_debit = data.directDebit;

      if (data.ecommerce) content.ecommerce = data.ecommerce;

      if (data.items) content.items = data.items;

      if (data.currency) content.currency = data.currency;

      if (data.transaction_id) content.transaction_id = data.transaction_id;

      if (data.qty_1st_data_plan != null) content.qty_1st_data_plan = data.qty_1st_data_plan;

      if (data.qty_2nd_data_plan != null) content.qty_2nd_data_plan = data.qty_2nd_data_plan;

      if (data.qty_3rd_data_plan != null) content.qty_3rd_data_plan = data.qty_3rd_data_plan;

      if (data.qty_4th_data_plan != null) content.qty_4th_data_plan = data.qty_4th_data_plan;

      if (data.userData) content.user_data = data.userData;

      track(content);
    },
    $gm_tracker_trackAction(name, label, origin) {
      const path = origin ? resolvePath(this.$route, origin) : window.location.pathname;

      const content = {
        event: 'simulador-action',
        event_category: path,
        event_action: name,
        event_label: label
      };

      track(content);
    },
    $gm_tracker_trackPageView(pathSuffix) {
      const routes = ['/simulador'];

      if (this.$route.params.package) {
        routes.push(`/${this.$route.params.package}`);
      }

      if (this.$route.params.coverage) {
        routes.push(`/${this.$route.params.coverage}`);
      }

      const path = routes.join('') + pathSuffix;
      const content = {
        event: 'simulador-pageview',
        event_path: path
      };

      track(content);
    },
    $gm_tracker_trackPageviewSite({ name = '', title } = { name: '', title: '' }) {
      const pathNamespace = this.globalConfig && this.globalConfig.analyticsNamespace ? `/${this.globalConfig.analyticsNamespace}` : '';
      const basePath = this.$route.params.package ? this.$route.params.package : '';
      let titleNamespace = '';

      switch (this.simulationTrackingPackage) {
        case 'casa':
        case 'casa-movel':
          titleNamespace = 'Simulador';
          break;
        case 'movel':
        case 'movel/pre':
        case 'movel/pos':
          titleNamespace = 'Telemóvel - Simulador';
          break;
        case 'singular':
        case 'colectiva':
          titleNamespace = 'Empresas - Simulador';
          break;
        default:
          titleNamespace = 'Simulador';
          break;
      }

      const content = {
        event: 'trackPageviewSite',
        page_name: `${pathNamespace}/${basePath ? `${basePath}/` : ''}${name ? `${name}/` : ''}`,
        page_title: `${title ? `${title} - ` : ''}${titleNamespace} - ${document.title}`
      };

      track(content, 'trackPageviewSite');
    },
    $gm_tracker_trackFormSubmission(name) {
      const content = {
        event: 'sendForm',
        formname: name
      };

      track(content, 'trackFormSubmission');
    },
    $gm_tracker_trackSummary() {
      const content = {
        event: 'simulador-summary',
        event_category: 'Simulador',
        event_action: this.$gm_tracker_getContext,
        event_label: this.cartStringifiedContent,
        event_value: this.$gm_tracker_getPrice
      };

      track(content, 'trackSummary');
    },
    $gm_tracker_getContext() {
      let context;

      switch (this.simulationPackage) {
        case 'casa':
          context = 'Para Casa/ Casa e Telemóvel';
          break;
        case 'movel':
        case 'movel.carregamentos':
        case 'movel.pospago':
          context = 'Para o Telemóvel';
          break;
        case 'singular':
          context = 'Pessoa Singular';
          break;
        case 'colectiva':
          context = 'Pessoa Colectiva';
          break;
        default:
          context = 'NOT_SELECTED';
      }

      return context;
    },
    $gm_tracker_getPrice() {
      let total = 0;

      const filteredItems = this.cart.filter(item => item.quantity && item.config.isListable);

      filteredItems.map((item) => {
        if (this.isPathAnOffer(item.path)) {
          return false;
        }

        const activePrice = this.determineActivePrice(item.price);

        const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
        const value = item.quantity * (activePrice.value + basePrice);

        total += value;

        return true;
      });

      return Math.round(total - this.validDiscountLoudOffersValue);
    },
    $fb_tracker_trackSubscribe(price) {
      window.fbq('track', 'Subscribe', { value: price, currency: 'EUR', predicted_ltv: '0.00' });
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/mixins/global/tracker.js